export const CHAT_TIMEOUT_MS = 45_000;
export const TIMEOUT_CHECK_INTERVAL_MS = 5_000;
export const INPUT_FOCUS_DELAY_MS = 1_000;
export const NAVIGATION_DELAY_MS = 300;
export const RECONNECT_FETCH_TIMEOUT_MS = 120_000;
export const HISTORY_SUMMARY_PENDING_MAX_ATTEMPTS = 3;
